import { isMainSearchTypeKeywords } from '../../util/search';
import { boltCircleSpellings } from '../../util/boltCircleCore';

/**
 * TopbarSearchForm values → listing-query params, for a search inside one
 * store on its profile: the ads (StoreListingsSection) and the catalogue
 * (CatalogueSection, P25009-410) search the same way, so a buyer who learns
 * one box knows the other.
 *
 * Same shape as the keyword branch of Topbar.handleSubmit. An empty search
 * gives no filters, so every listing in that section comes back.
 *
 * @param {Object} values the form's values
 * @param {Object} config the app configuration
 * @returns {Object} pub_* / keywords params
 */
export const storeSearchParams = (values = {}, config) => {
  if (!isMainSearchTypeKeywords(config)) return {};
  if (values.numberOfBolts && values.boltCircle) {
    return {
      pub_numberOfBolts: values.numberOfBolts,
      // Every stored spelling of the circle (P25009-488).
      pub_boltCircle: boltCircleSpellings(values.boltCircle).join(',') || values.boltCircle,
      pub_adType: values.adType || 'rim',
    };
  }
  if (values.diameter && values.adType === 'rim') {
    return { pub_diameter: values.diameter, pub_adType: values.adType };
  }
  if (values.categoryLevel1 && values.adType === 'rim') {
    return {
      pub_categoryLevel1: values.categoryLevel1,
      // Only constrain by model when one was chosen — an empty
      // pub_categoryLevel2 would filter to listings with NO model
      // and exclude e.g. all "Volvo XC60" listings.
      ...(values.categoryLevel2 ? { pub_categoryLevel2: values.categoryLevel2 } : {}),
      pub_adType: values.adType,
    };
  }
  if (values.tireWidthFront && values.profileFront && values.diameter) {
    return {
      pub_tireWidthFront: values.tireWidthFront,
      pub_profileFront: values.profileFront,
      pub_diameter: values.diameter,
    };
  }
  if (values.categoryLevel1) {
    return {
      pub_categoryLevel1: values.categoryLevel1,
      ...(values.categoryLevel2 ? { pub_categoryLevel2: values.categoryLevel2 } : {}),
    };
  }
  return values.keywords ? { keywords: values.keywords } : {};
};

export default storeSearchParams;
